import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin"
        ? [
            {
              id: 1,
              label: "Home",
              icon: WSIcons.Home,
              path: "/home"
            },

            {
              id: 16,
              label: "Pickup Order",
              icon: WSIcons.PickupVanIcon,
              path: "/pickup-order/list"
            },

            {
              id: 18,
              label: "Walk-in Order",
              icon: WSIcons.StrightWalkIcon,
              path: "/new-walk-in-order"
            },

            {
              id: 2,
              label: "Masters",
              icon: WSIcons.Masters,
              children: [
                {
                  id: 155,
                  label: "Users",
                  path: "/user/list"
                },

                {
                  id: 20,
                  label: "Customer",
                  path: "/customer/list"
                },

                {
                  id: 21,
                  label: "Franchise",
                  icon: WSIcons.ShoppingBagIcon,
                  path: "/franchise/list"
                },

                
                {
                  id: 6,
                  label: "Product",
                  path: "/product/list"
                },

                {
                  id:7,
                  label:"Rider",
                  path:"/rider/list"
                },

                {
                  id: 8,
                  label: "Service",
                  path: "/service/list"
                },

                // {
                //   id:9,
                //   label:"Loyalty",
                //   path:"/loyalty/history"
                // },

                {
                  id:10,
                  label:"Refer & Earn",
                  path:"loyalty/referel"
                },

                {
                  id: 337,
                  label: "Add On Service",
                  path: "/add-on-service/list"
                },
                {
                  id: 25,
                  label: "Map Service",
                  icon: WSIcons.PaymentsIcon,
                  path: "/service-product-map/list"
                },
                {
                  id: 26,
                  label: "Map Product",
                  icon: WSIcons.WithoutPay,
                  path: "/product-service-map/list"
                }
              ]
            },

            // {
            //   id: 17,
            //   label: "B2C Order",
            //   icon: WSIcons.ShoppingCartIcon,
            //   path: "/b2c-order"
            // },

            // {
            //   id: 20,
            //   label: "Fab Credit",
            //   icon: WSIcons.CreditCardIcon,
            //   path: "/fab-credit"
            // },

            // {
            //   id: 22,
            //   label: "Settlement",
            //   icon: WSIcons.DoneAllIcon,
            //   path: "/settlement"
            // },
            // { id: 23, label: "Bill", icon: WSIcons.ReceiptIcon, path: "/bill" },
            {
              id: 24,
              label: "Payment",
              icon: WSIcons.PaymentsIcon,
              path: "/payment"
            },

            {
              id: 25,
              label: "Delivered",
              icon: WSIcons.DoneAllIcon,
              path: "/delivered/list"
            },

            {
              id:26,
              label:"Loyalty Rules",
              icon:WSIcons.CreditCardIcon,
              path:'/loyalty/rules'
            },

            {
              id: 33,
              label: "Logout",
              icon: WSIcons.LogOut,
              path: "/logout"
              // color: "red"
            }
          ]
        : [
            {
              id: 1,
              label: "Home",
              icon: WSIcons.Home,
              path: "/home"
            },

            {
              id: 16,
              label: "Pickup Order",
              icon: WSIcons.PickupVanIcon,
              path: "/pickup-order/list"
            },

            {
              id: 18,
              label: "Walk-in Order",
              icon: WSIcons.StrightWalkIcon,
              path: "/new-walk-in-order"
            },

            {
              id: 2,
              label: "Masters",
              icon: WSIcons.Masters,
              children: [
                {
                  id: 155,
                  label: "Users",
                  path: "/user/list"
                },
                {
                  id: 21,
                  label: "Franchise",
                  icon: WSIcons.ShoppingBagIcon,
                  path: "/franchise/list"
                },

                {
                  id: 20,
                  label: "Customer",
                  path: "/customer/list"
                },

                {
                  id: 6,
                  label: "Product",
                  path: "/product/list"
                },
                {
                  id:7,
                  label:"Rider",
                  path:"/rider/list"
                },


                {
                  id: 8,
                  label: "Service",
                  path: "/service/list"
                },

                {
                  id:9,
                  label:"Loyalty",
                  path:"/loyalty/history"
                },

                {
                  id:10,
                  label:"Refer & Earn",
                  path:"loyalty/referel"
                },
                
                {
                  id: 337,
                  label: "Add On Service",
                  path: "/add-on-service/list"
                },
                {
                  id: 25,
                  label: "Map Service",
                  icon: WSIcons.PaymentsIcon,
                  path: "/service-product-map/list"
                },
                {
                  id: 26,
                  label: "Map Product",
                  icon: WSIcons.WithoutPay,
                  path: "/product-service-map/list"
                }
              ]
            },

            // {
            //   id: 17,
            //   label: "B2C Order",
            //   icon: WSIcons.ShoppingCartIcon,
            //   path: "/b2c-order"
            // },

            // {
            //   id: 20,
            //   label: "Fab Credit",
            //   icon: WSIcons.CreditCardIcon,
            //   path: "/fab-credit"
            // },

            // {
            //   id: 22,
            //   label: "Settlement",
            //   icon: WSIcons.DoneAllIcon,
            //   path: "/settlement"
            // },
            // { id: 23, label: "Bill", icon: WSIcons.ReceiptIcon, path: "/bill" },
            {
              id: 24,
              label: "Payment",
              icon: WSIcons.PaymentsIcon,
              path: "/payment"
            },

            {
              id: 25,
              label: "Delivered",
              icon: WSIcons.DoneAllIcon,
              path: "/delivered/list"
            },

            {
              id:26,
              label:"Loyalty Rules",
              icon:WSIcons.CreditCardIcon,
              path:'/loyalty/rules'
            },

            {
              id: 33,
              label: "Logout",
              icon: WSIcons.LogOut,
              path: "/logout"
              // color: "red"
            }
          ]
  };
};
